import { render, staticRenderFns } from "./JoinForm.vue?vue&type=template&id=bf504470&scoped=true"
import script from "./JoinForm.vue?vue&type=script&lang=js"
export * from "./JoinForm.vue?vue&type=script&lang=js"
import style0 from "./JoinForm.vue?vue&type=style&index=0&id=bf504470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf504470",
  null
  
)

export default component.exports